import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const TopYouTubeVideos = () => {
  const videos = [
    { id: '_Ct5AFIgqxE', title: 'Roth IRA vs Traditional IRA - Considerations' },
    { id: 'fXHc2xE5xyY', title: 'Understanding Taxes on Social Security Benefits' },
    { id: '3mGTATYTVto', title: 'Exploring Retirement Withdrawal Strategies' },
    { id: 'wEdMuvOH8tM', title: 'Medicare Supplement vs Medicare Advantage Overview' },
    { id: 'tSJT5zhUhms', title: 'Factors to Consider When Claiming Social Security' },
    { id: 'uJBSn4cgGN4', title: 'Tax-Aware Retirement Income Concepts' },
    { id: 'R8iZzMSAmrY', title: 'Approaches to Managing Taxes in Retirement' },
    { id: 'QbbakhQkN2k', title: 'Additional Retirement Planning Considerations' },
    { id: 'iA8mdhkXHsk', title: 'Advanced Tax-Aware Strategies for Retirees' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Popular Videos from Dan's YouTube Channel
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Please note: RMD ages, contribution limits, and tax brackets may have changed since these recordings. The general concepts discussed are for educational purposes only.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <Card key={video.id} className="overflow-hidden hover:shadow-lg transition-shadow">
              <CardContent className="p-0">
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={video.title}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-900 line-clamp-2">
                    {video.title}
                  </h3>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="text-xs text-gray-500 text-center mt-6 max-w-3xl mx-auto">
          These videos are for educational and informational purposes only. They do not constitute investment advice, tax advice, or a recommendation to buy or sell any securities. The information presented may not reflect current tax laws or regulations. Individual circumstances vary. Please consult with qualified tax and financial professionals before making any financial decisions. Bridgeriver Advisors does not provide tax or legal advice.
        </p>
      </div>
    </section>
  );
};

export default TopYouTubeVideos;
